import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 10px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};
  padding-bottom: 20px;

  grid-area: ${({ gridArea }) => gridArea};
`;

export const Commitments = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;

  width: 100%;
`;

export const Commitment = styled.img`
  width: 110px;
  height: 110px;
  cursor: pointer;

  border: ${({ theme, selected }) =>
    selected ? `2px solid ${theme.colors.primary.vividCerulean}` : "none"};

  /* Itens NÃO selecionados ficam acinzentados e mais claros, facilitando
     visualizar quais estão selecionados. No hover, voltam à cor cheia. */
  filter: ${({ selected }) =>
    selected ? "none" : "grayscale(0.7) opacity(0.45)"};

  transition:
    border 0.03s,
    filter 0.15s ease;

  &:hover {
    filter: none;
  }
`;
